module.exports = __webpack_public_path__ + "static/media/logoCemmob-small.a840184a.svg";